export const SET_PRICING_TEMPLATES = 'SET_PRICING_TEMPLATES'
export const SET_WEIGHT_TOLERANCES = 'SET_WEIGHT_TOLERANCES'



// WEBPACK FOOTER //
// ./src/types/pricingTemplate.js